module.exports = __webpack_public_path__ + "static/media/Brands_17.111ba638.png";